<template>
    <div class="heading-elements">
        <ul class="list-inline mb-0">
            <li>
                <a
                    @click="toggleCollapse"
                >
                    <SVGMinimemIcon v-if="openStatus" />
                    <SVGMaximumIcon v-else />
                </a>
            </li>
            <slot></slot>
        </ul>
    </div>
</template>
<script>
import { toRefs, ref, watch } from '@vue/composition-api'
import SVGMaximumIcon from '@/assets/images/icons/maximum.svg'
import SVGMinimemIcon from '@/assets/images/icons/minimum.svg'
export default {
    components: {
        SVGMaximumIcon,
        SVGMinimemIcon
    },
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    setup (props, context) {
        const { open } = toRefs(props)
        const openStatus = ref(open.value)
        const toggleCollapse = () => {
            openStatus.value = !openStatus.value
            context.emit('card:collapse', openStatus.value)
        }
        watch(open, (value, oldValue) => {
            openStatus.value = value
        })
        return {
            openStatus,
            toggleCollapse
        }
    }
}
</script>
<style scoped>
.card .card-header .heading-elements a svg {
    height: auto;
    width: auto;
}
</style>
